import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'
import { SeoLink } from 'reducers/seo/breadCrumbs'

export enum Place {
  profile = 'profile',
  landing = 'landing',
}

export const BreadCrumbs: FC<{ links: SeoLink[]; place?: Place }> = ({
  links = [],
  place,
}) => {
  const { locale } = useShallowEqualSelector(
    ({ systemReducer: { locale } }) => ({
      locale,
    })
  )

  /**
   * Для meta
   * ItemProps
   */
  const metaContentIndex = place === Place.profile ? 2 : 1

  return (
    <BreadCrumbList itemScope itemType="https://schema.org/BreadcrumbList">
      {place === Place.profile && (
        <BreadCrumbItem
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <BreadCrumbItemLink itemProp="item" to={mergeAllUrls(locale)}>
            <BreadCrumbText itemProp="name">
              <FormattedMessage id="app.rating" defaultMessage="Знакомства" />
            </BreadCrumbText>
            <BreadcrumbsDelimiter>/</BreadcrumbsDelimiter>
          </BreadCrumbItemLink>
          <meta itemProp="position" content="1" />
        </BreadCrumbItem>
      )}
      {links.map(({ text, url }, index) => (
        <BreadCrumbItem
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          key={url}
        >
          <BreadCrumbItemLink itemProp="item" to={url}>
            <BreadCrumbText itemProp="name">{text}</BreadCrumbText>
            {links.length - 1 !== index && (
              <BreadcrumbsDelimiter>/</BreadcrumbsDelimiter>
            )}
          </BreadCrumbItemLink>
          <meta itemProp="position" content={`${index + metaContentIndex}`} />
        </BreadCrumbItem>
      ))}
    </BreadCrumbList>
  )
}

export const BreadCrumbList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
`

export const BreadCrumbItem = styled.li`
  display: inline-block;
`

export const BreadCrumbItemLink = styled(Link)`
  display: inline-block;
  font-size: 15px;
  color: ${Colors.disabledIcon};
  line-height: 1.6;
  text-decoration: none;
`

export const BreadCrumbText = styled.span`
  vertical-align: middle;
`

export const BreadcrumbsDelimiter = styled.span`
  display: inline-block;
  margin: 0 4px;
  vertical-align: middle;
`
